import { boolPropsToClassNames } from 'common/utils/style.utils';
import _ from 'lodash';
import Icon from 'components/base/Icon';
import React, { useState } from 'react';
import { StyledTableCell, StyledTableRow } from './Table.styles';
import SpecialRowTypes from './SpecialRows/SpecialRowTypes';
import { CircularProgress } from '@material-ui/core';

const getTransitionProps = ({ enabled, className, timeout }) =>
  enabled
    ? {
        className,
        transition: {
          timeout,
          className
        }
      }
    : {};

const TableRow = ({
  row,
  columns,
  drawByDataPoint,
  styles,
  lineHighlightOnHover,
  transitionProps,
  onRowClick = _.noop(),
  sortBy,
  isRowsExpandable,
  isExpanded,
  toggleIsExpanded,
  expandLevel = 0
}) => {
  const { rowType, onExpandClick, isRowLoading } = row;
  const [isHover, setIsHover] = useState(false);

  const rowChildren = _.get(row, 'children', []);
  const teamHasNoData = _.get(row, 'teamHasNoData', false);
  const hasChildren = rowChildren.length > 0;

  // switch of SpecialRow types
  if (rowType) return <SpecialRowTypes row={row} />;

  return (
    <StyledTableRow
      {...(teamHasNoData
        ? { style: { visibility: 'hidden', display: 'none', height: '0' } }
        : {})}
      cursor={styles.cursor}
      disabled={styles.disabled}
      hover={lineHighlightOnHover}
      backgroundcolor={styles.backgroundColor}
      grayedout={styles.grayedOut ? 'true' : null}
      highlight={styles.highlight ? 'true' : null}
      component='div'
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      {...(onRowClick && { onClick: () => onRowClick(row) })}
      {...getTransitionProps(transitionProps)}
    >
      {columns
        .map((column, idx) => {
          const {
            padding,
            width,
            tableCellProps,
            dataPoint,
            showOnlyOnHover,
            subscribeOnHover,
            rowAlign
          } = column;
          const isFirstCol = idx === 0;
          const content = drawByDataPoint
            ? row[dataPoint]
            : Object.values(row)[idx];
          const sortByKey = column.sortPoint || column.dataPoint;
          const isSorted = sortByKey === sortBy;

          return (
            <StyledTableCell
              component='div'
              key={idx}
              scope='row'
              className={boolPropsToClassNames({
                isSorted,
                isFirstCol,
                isRowsExpandable
              })}
              level={expandLevel}
              {...(padding ? { padding } : {})}
              {...(width ? { width } : {})}
              {...(tableCellProps ? tableCellProps : {})}
            >
              <span
                style={{
                  ...(showOnlyOnHover && !isHover
                    ? { visibility: 'hidden' }
                    : {}),
                  ...(rowAlign === 'right' ? { float: 'right' } : {})
                }}
              >
                {isRowsExpandable && (
                  <div className='row-expand-toggle' onClick={toggleIsExpanded}>
                    {isFirstCol &&
                      hasChildren &&
                      (isRowLoading ? (
                        <CircularProgress size={15} />
                      ) : isExpanded ? (
                        <Icon name='remove' color='shark' />
                      ) : (
                        <Icon
                          name='add'
                          color='shark'
                          onClick={() => {
                            onExpandClick && onExpandClick(row);
                          }}
                        />
                      ))}
                  </div>
                )}

                {subscribeOnHover && _.isFunction(content)
                  ? content(isHover)
                  : content}
              </span>
            </StyledTableCell>
          );
        })
        .filter(Boolean)}
    </StyledTableRow>
  );
};

export default TableRow;
